import { debounce } from 'lodash'

export default class MenuColor {
  constructor (view) {
    this.view = view
    this.menu = this.view.$parent.$children[0]
    this.observer = undefined
    this.elems = []
    this.visibles = []
    this.offsetTop = 35
    this.defaultColor = 'black'
    this.resized = false

    this.intersect = this.intersect.bind(this)
    this.resize = debounce(this.resize.bind(this), 500)

    this.view.$nextTick(() => {
      this.init()
    })
  }

  init () {
    this.elems = Array.from(document.querySelectorAll('[data-menucolor]'))
    this.elems.forEach((elem, key) => {
      elem.menucolor = elem.getAttribute('data-menucolor')
      elem.menucolorkey = key
    })

    // if (this.view.platform === 'desktop') window.addEventListener('resize', this.resize)
    window.addEventListener('resize', this.resize)
    this.observe()
  }

  destroy () {
    this.unobserve()
    window.removeEventListener('resize', this.resize)
  }

  intersect (entries, observer) {
    if (this.resized) {
      // this.resized = false
      return
    }
    // this.elems.forEach(elem => elem.isVisible)
    let selected
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        selected = entry.target
      }

      if (entry.isIntersecting) {
        if (!this.visibles.includes(entry.target.menucolorkey)) {
          this.visibles.push(entry.target.menucolorkey)
        }
      } else {
        if (this.visibles.includes(entry.target.menucolorkey)) {
          this.visibles = this.visibles.filter(i => i !== entry.target.menucolorkey)
        }
      }
    })

    // if (selected && selected.menucolor) {
    //   this.menu.color = selected.menucolor
    // } else {
    //   this.menu.color = this.defaultColor
    // }
    if (this.visibles.length) {
      this.menu.color = this.elems[this.visibles[this.visibles.length - 1]].menucolor
    } else {
      this.menu.color = this.defaultColor
    }
  }

  observe () {
    this.observer = new IntersectionObserver(this.intersect, {
      rootMargin: `-${this.offsetTop}px 0px -${window.innerHeight - this.offsetTop - 1}px 0px`
    })

    this.elems.forEach(elem => this.observer.observe(elem))
  }

  unobserve () {
    if (this.observer) {
      this.elems.forEach(elem => this.observer.unobserve(elem))
      this.observer = undefined
    }
  }

  resize () {
    this.resized = false

    this.unobserve()
    this.observe()

    setTimeout(() => {
      this.resized = false
    }, 100)
  }
}

// class MenuColor {
//   constructor (view) {
//     this.view = view
//     this.els = []
//     this.coordinates = []
//     this.ticking = false
//     this.scrollY = window.scrollY
//     this.margin = 35
//     this.menu = view.$parent.$children[0] // TODO dégeu
//
//     view.$nextTick(() => {
//       this.init()
//     })
//
//     window.addEventListener('resize', this.init.bind(this))
//     window.addEventListener('scroll', this.onScroll.bind(this))
//
//     this.onScroll()
//   }
//
//   init () {
//     this.els = Array.from(this.view.$el.querySelectorAll('[data-menucolor]'))
//     const footer = document.querySelector('footer.footer')
//     if (footer) this.els.push(footer)
//     for (var i = 0; i < this.els.length; i++) {
//       let offset
//       this.els[i].classList.contains('section-cover') ? offset = 100 : offset = 0
//       if(this.els[i].classList.contains('home-header'))  {
//         window.innerWidth < 813? offset = 0 : offset = 75
//       }else{
//         offset = 0
//       }
//       this.coordinates[i] = {
//         top: this.els[i].offsetTop,
//         bottom: this.els[i].offsetTop + this.els[i].offsetHeight - offset
//       }
//     }
//   }
//
//   update () {
//     console.log(this.els)
//     for (var i = 0; i < this.els.length; i++) {
//       let offset
//       if(window.innerWidth < 813){
//         offset = 0
//       } else {
//         if(this.els[i].classList.contains('section-cover')){
//           offset = 100
//         } else if(this.els[i].classList.contains('home-header')){
//           offset = 75
//         } else{
//           offset = 0
//         }
//       }
//
//       this.coordinates[i] = {
//         top: this.els[i].offsetTop - offset,
//         bottom: this.els[i].offsetTop + this.els[i].offsetHeight - offset
//       }
//     }
//   }
//
//   onScroll () {
//     let current
//     // console.log('ici')
//     if (!this.ticking) {
//       window.requestAnimationFrame(() => {
//         this.scrollY = window.scrollY + this.margin
//         if (this.scrollY < this.margin) {
//           current = 0
//         } else {
//           for (let i = 0; i < this.coordinates.length; i++) {
//             if (this.scrollY >= this.coordinates[i].top && this.scrollY < this.coordinates[i].bottom) {
//               current = i
//               break
//             }
//           }
//         }
//
//         if (this.els[current]) {
//           this.menu.color = this.els[current].getAttribute('data-menucolor')
//         } else {
//           this.menu.color = 'black'
//         }
//
//         this.ticking = false
//       })
//     }
//     this.ticking = true
//   }
// }
//
// export default MenuColor
